<template>
    <div class="d-flex justify-center fill-height page">
        <v-container class="px-2">
            <div class="wrapper d-flex align-start flex-column fill-height mx-auto px-lg-7 pt-4">
                <v-card flat class="form-wrapper" :class="{'transparent': phoneOnly, 'bordered': pcOnly}">
                    <!-- <v-card-title class="pt-0 text-center justify-center mb-1">تسجيل الدخول</v-card-title>
                    <v-card-subtitle class="text-center mb-6">قم بتسجيل الدخول إلى حسابك اﻵن</v-card-subtitle> -->
                    <div class="d-flex justify-center pa-4 mb-3">
                        <logo />
                    </div>
                    <!-- <v-divider class="my-3 mx-4" /> -->
                    <v-card-text class="pb-0 px-0">
                        <form @submit.prevent="login" class="login-form">
                            <v-text-field placeholder="أدخل البريد اﻹلكتروني أو رقم الهاتف" label="البريد الإلكتروني أو رقم الهاتف" name="email" v-model="email" autofocus :disabled="loading" outlined hide-details></v-text-field> <!-- :loading="loading" -->
                            <v-text-field placeholder="أدخل كلمة المرور" label="كلمة المرور" outlined name="password" hide-details v-model="password" :disabled="loading" class="my-5" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field> <!-- :loading="loading" -->
                            <div class="d-flex justify-space-between align-center mb-4">
                                <div>
                                    <v-checkbox v-model="remember" :disabled="loading" label="تذكرني" class="ma-0" hide-details></v-checkbox>
                                </div>
                                <div>
                                    <v-btn text dense to="/reset-password" :disabled="loading" class="forget-password grey--text px-2">نسيت كلمة المرور؟</v-btn>
                                </div>
                            </div>
                            <v-btn type="submit" block depressed large :loading="loading" :disabled="loading" color="primary" @click.prevent="login">تسجيل الدخول</v-btn>
                        </form>
                        
                        <div class="footer mt-4 text-center">
                            <div class="small-text">
                                باستخدامك للمنصة فأنت توافق على 
                                <v-btn text height="20" dense :to="'/privacy-policy'" :disabled="loading" small class="strong-text--text px-0"><span class="small-text">سياسة الخصوصية</span></v-btn>
                                <v-btn text height="20" dense :to="'/terms'" :disabled="loading" small class="strong-text--text px-0 ms-1"><span class="small-text">وشروط الاستخدام</span></v-btn>
                            </div>
                            <div>
                                ليس لديك حساب؟
                                <v-btn text dense :to="{name: 'register'}" :disabled="loading" class="primary--text px-1">حساب جديد</v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-container>

        <slot name="footer" />
    </div>
</template>

<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppAPI from '@/app-api'

export default {
    name: 'login',
    data(){
        return {
            email: '',
            password: '',
            remember: true,
            loading: false,
            showPassword: false,

            deviceToken: null,
        };
    },
    components: {
        
    },
    computed:{
        ...GlobalComputed 
    },
    methods: {
        ...GlobalMethods,
        
        async login(){
            const self = this;
            if (!this.deviceToken && this.capRunning && this.isProduction){
                await this.getFcmToken();
            }
            self.loginAction(self.email, self.password, self.remember, self.deviceToken);
        },
        loginAction(email, password, remember = true, deviceToken=null){
             
            if (email && password){
                if (!this.loading){
                    this.loading = true;
    
                    let data = { email, password, remember };
                    if (deviceToken){
                        data.deviceToken = deviceToken;
                    }
                    
                    this.$store.dispatch('loginAction', data).then(()=>{
                        this.loading = false;
                        const redirect = this.$route.query.redirect;
                        if (redirect) {
                            this.$router.push(redirect);
                        } else {
                            this.$router.push({name: 'home', query: this.$route.query});
                        }
                    }).catch(error=>{
                        this.loading = false;
                        if (error.response && (error.response.status === 401)){
                            this.showLoginMsg('البريد الإلكتروني أو كلمة المرور غير صحيحة');
                        }else if (error.response && error.response.status === 403 && error.response.data.message === 'MAX_TOKENS_EXCEEDED'){
                            this.showLoginMsg('لقد تجاوزت عدد اﻷجهزة المسموح به، سجل خروج من أحد أجهزتك أو تواصل مع الدعم');
                        }else if (error.response && error.response.data.message === 'SUSPENDED_ACCOUNT'){
                            this.showLoginMsg('لقد تم حظر حسابك، تواصل مع الدعم');
                        }else if (error.response && error.response.data.message === 'NOT_ACTIVATED_ACCOUNT'){
                            this.showLoginMsg('الحساب لا يزال قيد المراجعة، انتظر حتى يتم قبوله.');
                        }else if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);
                        }else{
                            this.showLoginMsg('حدثت مشكلة أثناء تسجيل الدخول');
                        }
                    })
                }
            }else{
                this.showLoginMsg("لا يمكنك ترك حقول فارغة")
            }
        },
        showLoginMsg(msg){
            this.showMsg(msg, 'error');
        },
        closeMsg(){
            if (this.$store.state.globalModule.snackMsg.text){
                this.$store.dispatch('addSnackMsg', {show: false, text: ''});
            }
        },
        checkAppAutoLogin(){
            if (!this.capRunning && this.phoneAndTablet && this.appData.enable_wallet_system){
                const saved_token = window.localStorage.getItem('tK');
                if (!saved_token){
                    let tk = this.$route.query.tk;
                    if (tk && this.$route.query.from === 'app' && this.$route.query.to === 'w'){
                        tk = tk.split('').reverse().join('');
                        // this.$router.push({query: {}});
                        window.localStorage.setItem('tK', tk);
                        // this.$router.push({name: 'wallet'});
                        let redirectTo = '/wallet';
                        if (this.$route.query.q){
                            redirectTo += '?';
                            redirectTo += this.$route.query.q.replaceAll(':', '=').replaceAll('|', '&');
                        }
                        window.location = redirectTo;
                    }
                }
            }
        },
        getFcmToken(){
            const self = this;
            return AppAPI.Notifications.getDeviceToken(
                response=>{
                    const deviceToken = response.token;
                    self.deviceToken = deviceToken;
                },
                error=>{
                    if (this.capRunning && this.isProduction){
                        window.console.error(error);
                    }
                },
            );
        }
    },
    watch: {
        email(){
            this.closeMsg();
        },
        password(){
            this.closeMsg();
        }
    },
    mounted(){
        if (this.capRunning && this.isProduction){
            this.getFcmToken();
        }
    },
    created(){
        this.checkAppAutoLogin();
    }
}
</script>

<style lang="scss" scoped>
    .wrapper{
        @media(min-width: 960px){
            padding-top: 5rem!important;
        }
    }
    .logo-wrapper{
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            max-width: 150px;
            min-width: 120px;
            height: auto;
        }
    }
    .social-btns{
        direction: ltr;
        display: flex;
        justify-content: space-between;
        margin: 1rem 0;
    }

</style>

<style lang="scss">
    .login-form{
        .v-input.v-text-field--outlined .v-label{
            line-height: 1!important;
        }
        .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
            margin-top: 13px!important;
        }
    }
</style>